import React from "react";

export default function PrivacyPolicyPG() {
  return (






   <>
   
    <section
      className="page-title"
      style={{
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(images/background/3.jpg)`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    color: 'white'
  }}
    >
      <div className="auto-container">
        <h1>Privacy Policy </h1>
       
      </div>
    </section>




    <div className="ppg-root">
      <section className="ppg-hero">
        <div className="ppg-container">
          <h1 className="ppg-title">Privacy-Policy</h1>
          <span className="ppg-title-underline" />
        </div>
      </section>

      <section className="ppg-container pgp-grid">
        {/* LEFT: MAIN CONTENT (exact user text) */}
        <article className="ppg-main">
          <h2 className="ppg-h2">
            Privacy Policy for Shree Swami Samarth PG: Safeguarding Your Personal Information
          </h2>

          <p className="ppg-p">
            At Shree Swami Samarth PG, we are committed to ensuring the privacy and security of
            the personal information of our residents and visitors. This Privacy Policy outlines
            our practices regarding the collection, use, and protection of your data. By choosing
            to reside at Shree Swami Samarth PG or engage with our services, you acknowledge that
            you have read, understood, and agreed to the terms of this Privacy Policy.
          </p>

          <h3 className="ppg-h3">Information We Collect:</h3>
          <p className="ppg-p">
            We collect personal information necessary for the provision of accommodation services,
            including but not limited to names, contact details, identification documents,
            emergency contact information, and relevant financial information for lease
            transactions.
          </p>

          <h3 className="ppg-h3">Use of Information:</h3>
          <p className="ppg-p">
            The personal information collected is used for the purpose of managing accommodation
            services, including lease agreements, rent payments, and communication with residents.
            We may also use your contact information to provide updates on community events and
            important announcements.
          </p>

          <h3 className="ppg-h3">Security Measures:</h3>
          <p className="ppg-p">
            We implement industry-standard security measures to protect your personal information
            from unauthorized access, disclosure, alteration, and destruction. Access to your data
            is restricted to authorized personnel only, and we regularly review our security
            protocols to ensure the ongoing protection of your information.
          </p>

          <h3 className="ppg-h3">Third-Party Disclosures:</h3>
          <p className="ppg-p">
            We do not disclose your personal information to third parties without your explicit
            consent, except where required by law or as part of providing essential services in
            such cases, we ensure that third parties adhere to similar privacy and security
            standards.
          </p>

          <h3 className="ppg-h3">Data Retention:</h3>
          <p className="ppg-p">
            We retain your personal information for the duration of your stay at Shree Swami
            Samarth PG and for a reasonable period thereafter. Financial information is retained
            as required by financial regulations. After this period, your data will be securely
            disposed of in accordance with applicable laws and regulations.
          </p>

          <h3 className="ppg-h3">Cookies and Analytics:</h3>
          <p className="ppg-p">
            Our website may use cookies and analytics tools to enhance user experience and collect
            anonymous data about website usage. This information is used to improve our online
            services and does not personally identify individuals.
          </p>

          <h3 className="ppg-h3">Updates to Privacy Policy:</h3>
          <p className="ppg-p">
            We may update this Privacy Policy to reflect changes in our practices or legal
            requirements. Residents will be notified of any significant changes, and the latest
            version of the policy will be available on our website.
          </p>

          <h3 className="ppg-h3">Residents' Rights:</h3>
          <p className="ppg-p">
            Residents have the right to access, correct, or request the deletion of their personal
            information. To exercise these rights or to make inquiries about your data, please
            contact our designated privacy officer at
          </p>

          <h3 className="ppg-h3">Consent:</h3>
          <p className="ppg-p">
            By engaging with Shree Swami Samarth PG services, you consent to the collection and
            use of your personal information as outlined in this Privacy Policy. You have the right
            to withdraw your consent at any time, subject to contractual and legal obligations.
          </p>

          <div className="ppg-note">
            <p className="ppg-p tight"><strong>Best Regards,</strong></p>
            <p className="ppg-p tight"><strong>Shree Swami Samarth PG Management Team</strong></p>
            <p className="ppg-p tight"><strong>Mo.No-</strong> +91 9209169761</p>
            <p className="ppg-p tight">
              <strong>Address-</strong> Shree Swami Samarth PG, M.No. 03065, No. 258/1/3, Mukai Nagar, B.H. MRF Showroom, Pune 411057
            </p>
          </div>
        </article>

        {/* RIGHT: CONTACT CARD (from your details) */}
        <aside className="ppg-aside" aria-label="Contact">
          <div className="ppg-contact">
            <h4>GET IN TOUCH</h4>
            <ul>
              <li>
                <span className="lbl">Phone:</span>
                <span className="val">+91 9209169761</span>
              </li>
              <li>
                <span className="lbl">Address:</span>
                <span className="val">
                  Shree Swami Samarth PG,<br />
                 M.No. 03065, No. 258/1/3, Mukai Nagar, B.H. MRF Showroom, Pune 411057
                </span>
              </li>
            </ul>
          </div>
        </aside>
      </section>


      {/* Scoped CSS */}
      <style>{`
        :root { --brand:#EAC2A4; --ink:#0f172a; --muted:#4b5563; --bg:#faf7f4; }
        .ppg-root{ background:#fff; color:var(--ink); }
        .ppg-container{ width:min(1200px,92%); margin:0 auto; }
        .ppg-hero{ background:var(--bg); border-bottom:1px solid #eee; }
        .ppg-title{ font-size:2rem; margin:1.2rem 0 .5rem; letter-spacing:.2px; }
        .ppg-title-underline{ display:block; width:90px; height:4px; background:var(--brand); border-radius:999px; margin-bottom:1rem; }

        .pgp-grid{ display:grid; grid-template-columns:2fr 1fr; gap:2rem; padding:1.5rem 0 2.5rem; }
        .ppg-main{ min-width:0; }
        .ppg-h2{ font-size:1.15rem; font-weight:700; color:#111827; margin:.25rem 0 1rem; }
        .ppg-h3{ font-size:1.05rem; font-weight:700; color:#111827; margin:1.75rem 0 .5rem; }
        .ppg-p{ color:var(--muted); font-size:1rem; line-height:1.9; margin:.35rem 0 1rem; }
        .ppg-p.tight{ margin:.2rem 0; }

        .ppg-note{ border:1px solid var(--brand); background:#fff9f5; border-radius:12px; padding:1rem; margin-top:1.25rem; }

        .ppg-aside{ min-width:260px; }
        .ppg-contact{
          position:sticky; top:88px;
          background:var(--brand); color:#231f20;
          border-radius:12px; padding:1.25rem;
          box-shadow:0 10px 30px rgba(0,0,0,.08) inset, 0 6px 24px rgba(0,0,0,.06);
        }
        .ppg-contact h4{ margin:0 0 .8rem; font-size:1.1rem; letter-spacing:.5px; }
        .ppg-contact ul{ list-style:none; margin:0; padding:0; display:grid; gap:.9rem; }
        .ppg-contact .lbl{ display:block; font-weight:800; margin-bottom:.1rem; }
        .ppg-contact .val{ display:block; }

        @media (max-width:1024px){ .pgp-grid{ grid-template-columns:1.6fr 1fr; } }
        @media (max-width:840px){
          .pgp-grid{ grid-template-columns:1fr; }
          .ppg-aside{ order:-1; }
          .ppg-contact{ position:relative; top:0; margin-bottom:1rem; }
        }
      `}</style>
    </div>
       </>
  );
}
